import { instance } from "libs/api";

import { ApiRoutesProducts } from "./../../constants/enums";
import { GetMerchantPriceResponse } from "./getMerchantPrice.types";

export const requestGetMerchantPrice =
  async (): Promise<GetMerchantPriceResponse> => {
    return await instance.get(ApiRoutesProducts.MerchantPrice);
  };
